/* eslint-disable import/prefer-default-export */
import paginateAction from '@utils/paginateAction';
import { schema } from 'normalizr';
import { batchGroupTypes } from '../constants';
import { batchGroupSchema, paginatorListSchema } from '../schemas';

export const fetchGroupBatchData = (batchUID) => (dispatch) =>
  dispatch({
    type: batchGroupTypes.FETCH_BATCHGROUPS_INFO,
    endpoint: `v2/batch/batch_group/${batchUID}/details/`,
    method: 'get',
    key: batchUID,
    schema: new schema.Object({ batchGroup: batchGroupSchema }),
    entityType: 'batchGroup'
  });

export const fetchTrialClasses = (batchUID) => (dispatch) =>
  dispatch({
    type: batchGroupTypes.FETCH_BATCHGROUPS_TRIAL_CLASSES,
    endpoint: `v1/batch/${batchUID}/trial_classes/`,
    method: 'get',
    key: batchUID
  });

const getEnrolledBatches = (key, resetWithoutEmpty) => (next) => ({
  type: batchGroupTypes.FETCH_ENROLLED_BATCHES,
  endpoint: next,
  method: 'get',
  key,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'batchGroup'
});

export const fetchEnrolledBatches = (
  goalUid,
  nextPage,
  resetWithoutEmpty = false
) => {
  const key = `${goalUid}-enrolled-batches`;
  return paginateAction(
    `v1/batch/enrolled_batch_group_data/?goal_uid=${goalUid}`,
    getEnrolledBatches(key, resetWithoutEmpty),
    'enrolledBatches',
    key,
    resetWithoutEmpty
  )(nextPage);
};

const getBatchGroupFreeClasses = (key, resetWithoutEmpty) => (next) => ({
  type: batchGroupTypes.FETCH_BATCH_GROUP_CLASSES,
  endpoint: next,
  method: 'get',
  key,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'course'
});

export const fetchBatchesGroupTrailClasses = (
  goalUID,
  nextPage,
  resetWithoutEmpty = false,
  forceReset = false,
  limit = 8,
  offset = 0
) => {
  const key = `${goalUID}-batch-group-free-classes`;
  return paginateAction(
    `v1/uplus/${goalUID}/special_classes/?limit=${limit}&offset=${offset}`,
    getBatchGroupFreeClasses(key, resetWithoutEmpty),
    'batchGroupFreeClasses',
    key,
    resetWithoutEmpty,
    forceReset
  )(nextPage);
};
